import { canListAddresses, canListUsers, canManageCompanies } from "@/helpers/permissions";
import type { PermissionSelector } from "@/hooks/usePermission";

export const canInviteUser: PermissionSelector = (x) => x.userManagement.canInviteUser;

export const canAssignRoles: PermissionSelector = (x) => x.userManagement.canAssignRoles;

const canBulkUploadUsers: PermissionSelector = (x) => x.userManagement.canBulkUploadUsers;

// Computed permission for FE to control route access
export const canAccessBulkUploadUsers: PermissionSelector = (x) =>
  canListUsers(x) &&
  canInviteUser(x) &&
  canBulkUploadUsers(x) &&
  ((x.projectType === "addressBased" && canListAddresses(x)) || canManageCompanies(x));
